export default {"src":"/_next/static/media/flower_terms.c34893f7.svg","height":519,"width":382,"blurWidth":0,"blurHeight":0};